export const LINE_COLORS = [
  '#8865cc',
  '#3fb0ed',
  '#67d386',
  '#e96799',
  '#ff8e70',
  '#dabd56',
];
